import Header from './components/Header'
import Hero from './components/Hero'
import Features from './components/Features'
import Architecture from './components/Architecture'
import ProblemSolution from './components/ProblemSolution'
import Mockups from './components/Mockups'
import Footer from './components/Footer'

function App() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero />
        <ProblemSolution />
        <Features />
        <Architecture />
        <Mockups />
      </main>
      <Footer />
    </div>
  )
}

export default App
